import React from 'react';
import leftArrow from 'assets/arrow_left_24px.svg';

type CallbackButtonProps = {
  callbackUri: string;
};

const CallbackButton = ({ callbackUri }: CallbackButtonProps) => {
  return (
    <a
      href={callbackUri}
      className="callbackButton text-neutral-90"
      title="Back to Cropwise Imagery"
    >
      <img src={leftArrow} alt="left button" width="12px" height="12px" className="arrow-image" />
      <span>Back to Cropwise Imagery</span>
    </a>
  );
};

export default CallbackButton;
